<template>
  <div class="index">
    <!-- 选择查询条件 -->
    <div class="index-header">
      <el-form :model="filterForm" :inline="true" label-width="100px">
        <div class="input-box">
          <div>
            <!-- <el-form-item label="被投诉人：">
              <el-input clearable v-model="filterForm.targetId" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="投诉人：">
              <el-input clearable v-model="filterForm.userId" placeholder="请输入姓名"></el-input>
            </el-form-item> -->
          </div>
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <areaFilter ref="areaFilter_filter" @getData="filterClick" />
          </div>
          <div>
            <el-form-item>
              <el-button type="primary" @click="filterClick()" icon="el-icon-search">查询</el-button>
              <el-button type="" @click="resetHandler()" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 用户操作按钮 -->
    <!-- <div class="edit">
      <el-button :disabled="selectRow.length!==1" icon="el-icon-edit" @click="modifyHandler">查看</el-button>
      <el-button :disabled="selectRow.length!==1" icon="el-icon-edit" @click="modifyHandler" v-if="powerShow.modify">编辑</el-button>
      <el-button :disabled="selectRow.length<1" icon="el-icon-delete" type="danger" @click="deleteHandler" v-if="powerShow.delete">删除</el-button>
    </div> -->
    <!-- 数据表格 -->
    <div class="table">
      <el-table :data="tableData_contract" max-height="550" border @selection-change="(val)=>{selectRow=val}">
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo_contract" :key="i"
          :prop="x.key" :label="x.value" :fixed="i<=5" align="center"></el-table-column>
        <el-table-column label="文件" width="362" align="center">
          <template slot-scope="scope">
            <p v-for="(x,i) in scope.row.fileNameAndIdList" :key="i" class="file-item">
              <span class="file-name">{{x.fileName}}</span>
              <!-- <a style="cursor: pointer;color:#409EFF;text-decoration: underline;" :download="x.fileName" :href="puUrl_x+'/'+x.fileId" target="_blank">{{x.fileName}}</a> -->
              <a :href="'https://view.officeapps.live.com/op/view.aspx?src='+puUrl_x+'/'+x.fileId" target="_blank">
                <el-button size="mini" plain type="success">预览</el-button>
              </a>
              <a :download="x.fileName" :href="puUrl_x+'/'+x.fileId" target="_blank" style="margin-left:10px;">
                <el-button size="mini" plain type="primary">下载</el-button>
              </a>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="支付凭证" width="121" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px" :src="scope.row.transferUrl|toimg" fit="fill"
              :preview-src-list="[puUrl_x+'/'+scope.row.transferUrl]" v-if="scope.row.transferUrl"></el-image>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="420" align="center"> -->
        <el-table-column label="操作" width="340" align="center">
          <template slot-scope="scope">
            <el-button size="mini" plain type="success" @click="signContractHandler(scope.row.id)" :disabled="scope.row.ok">签约</el-button>
            <el-button size="mini" plain type="success" @click="payContractHandler(scope.row.id, scope.row)" :disabled="!scope.row.ok">支付</el-button>
            <el-button size="mini" plain type="success" @click="applyInvoiceHandler(scope.row.id)" :disabled="!scope.row.ok">申请发票</el-button>
            <!-- <el-button size="mini" plain type="success" @click="createInterviewHandler(scope.row.id)" :disabled="!scope.row.ok">发起面试</el-button> -->
            <el-button size="mini" plain type="success" @click="viewInterviewHandler(scope.row.id)" :disabled="!scope.row.ok">查看面试</el-button>
          </template>
        </el-table-column>
      </el-table>
      <paging :pagesData="pageData" @set_page_number="pageNumberChange_contract"></paging>
    </div>

    <!-- 模态框 发起面试 -->
    <el-dialog
      title="面试信息" :modal="false" width="1400px" center
      :visible.sync="centerDialogVisible_interview_create"
      :close-on-click-modal="false" @close="dialogClose_interview_create">
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="140px" ref="editFor_interview_create" size="mini" :model="editForm_interview_create">
                    <el-col :span="12">
                      <el-form-item label="序列号">
                        <el-input style="width:360px;" v-model="editForm_interview_create.no" disabled></el-input>
                        <!-- <span>{{editForm_interview_create.no}}</span> -->
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="面试邀请名称">
                        <el-input style="width:360px;" v-model="editForm_interview_create.inviteName" disabled></el-input>
                        <!-- <span>{{editForm_interview_create.inviteName}}</span> -->
                      </el-form-item>
                      <!-- <el-form-item label="单位名称">
                        <el-input style="width:360px;" v-model="editForm_interview_create.organization" disabled></el-input>
                      </el-form-item>
                      <el-form-item label="单位QQ/E-mail">
                        <el-input style="width:360px;" v-model="editForm_interview_create.qq" disabled></el-input>
                      </el-form-item> -->
                    </el-col>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">面试安排</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="140px" ref="editFor_interview_create" size="mini" :model="editForm_interview_create">
                    <el-col :span="12">
                      <div v-for="(x,i) in editForm_interview_create.interviewArrangeList" :key="i">
                        <el-form-item :label="'场次日期 '+(i+1)">
                          <!-- <el-input style="width:360px;" v-model="x.time" disabled></el-input> -->
                          
                          <el-date-picker
                            size="mini" type="datetime" default-time="00:00:00" v-model="x.time" disabled style="width:360px;"
                            format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
                          <!-- <span>{{x.time}}</span> -->
                        </el-form-item>
                        <el-form-item :label="'开始时间 '+(i+1)">
                          <el-input style="width:360px;" v-model="x.startTime" disabled></el-input>
                          <!-- <span>{{x.startTime}}</span> -->
                        </el-form-item>
                        <el-form-item :label="'结束时间 '+(i+1)">
                          <el-input style="width:360px;" v-model="x.endTime" disabled></el-input>
                          <!-- <span>{{x.endTime}}</span> -->
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div v-for="(x,i) in editForm_interview_create.interviewArrangeList" :key="i">
                        <el-form-item :label="'活动内容 '+(i+1)">
                          <el-input style="width:360px;" v-model="x.activity" disabled></el-input>
                          <!-- <span>{{x.activity}}</span> -->
                        </el-form-item>
                        <el-form-item :label="'场次地点 '+(i+1)">
                          <el-input style="width:360px;" v-model="x.address" disabled></el-input>
                          <!-- <span>{{x.address}}</span> -->
                        </el-form-item>
                        <el-form-item>
                          <el-input style="visibility: hidden;"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">面试指南</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="140px" ref="editFor_interview_create" size="mini" :model="editForm_interview_create">
                    <el-col :span="12">
                      <el-form-item label="大厅名称">
                        <el-input style="width:360px;" v-model="editForm_interview_create.daTing" disabled></el-input>
                        <!-- <span>{{editForm_interview_create.daTing}}</span> -->
                      </el-form-item>
                      <el-form-item label="用户名">
                        <el-input style="width:360px;" v-model="editForm_interview_create.name" disabled></el-input>
                        <!-- <span>{{editForm_interview_create.name}}</span> -->
                      </el-form-item>
                      <el-form-item label="密码">
                        <el-input style="width:360px;" v-model="editForm_interview_create.password" disabled></el-input>
                        <!-- <span>{{editForm_interview_create.password}}</span> -->
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="书面电邮反馈月份">
                        <el-input style="width:360px;" v-model="editForm_interview_create.month" disabled></el-input>
                        <!-- <span>{{editForm_interview_create.month}}</span> -->
                      </el-form-item>
                      <el-form-item label="书面电邮反馈日号">
                        <el-input style="width:360px;" v-model="editForm_interview_create.day" disabled></el-input>
                        <!-- <span>{{editForm_interview_create.day}}</span> -->
                      </el-form-item>
                    </el-col>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="edit-box" v-if="!!editForm_interview_create.organization||isShowFeedback">
          <div class="edit-item">
            <div class="edit-left">面试回执</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="140px" ref="editFor_interview_create" size="mini" :model="editForm_interview_create">
                    <el-col :span="12">
                      <el-form-item label="单位名称">
                        <el-input style="width:360px;" v-model="editForm_interview_create.organization" :disabled="!isShowFeedback"></el-input>
                      </el-form-item>
                      <div v-for="(x,i) in editForm_interview_create.interviewDocList" :key="i">
                        <el-form-item :label="'姓名 '+(i+1)">
                          <el-input style="width:360px;" v-model="x.name" :disabled="!isShowFeedback"></el-input>
                          <!-- <span>{{x.name}}</span> -->
                        </el-form-item>
                        <el-form-item :label="'职务 '+(i+1)">
                          <el-input style="width:360px;" v-model="x.title" :disabled="!isShowFeedback"></el-input>
                          <!-- <span>{{x.title}}</span> -->
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="单位QQ/E-mail">
                        <el-input style="width:360px;" v-model="editForm_interview_create.qq" :disabled="!isShowFeedback"></el-input>
                      </el-form-item>
                      <div v-for="(x,i) in editForm_interview_create.interviewDocList" :key="i">
                        <el-form-item :label="'性别 '+(i+1)">
                          <el-input style="width:360px;" v-model="x.sex" :disabled="!isShowFeedback"></el-input>
                          <!-- <span>{{x.sex}}</span> -->
                        </el-form-item>
                        <el-form-item :label="'手机 '+(i+1)">
                          <el-input style="width:360px;" v-model="x.phone" :disabled="!isShowFeedback"></el-input>
                          <!-- <span>{{x.phone}}</span> -->
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="success" @click="addInterview()">增加场次行</el-button> -->
        <el-button type="success" @click="addFeedback()" v-if="isShowFeedback">增加回执行</el-button>
        <el-button @click="dialogClose_interview_create()">取 消</el-button>
        <el-button type="primary" @click="dialogSubmit_interview_create()" v-if="isShowFeedback">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 模态框 查看面试 -->
    <el-dialog
      title="面试列表" :modal="false" width="1400px" center
      :visible.sync="centerDialogVisible_interview_view"
      :close-on-click-modal="false" @close="dialogClose_interview_view">
      <el-table :data="tableData_interview" max-height="550" border @selection-change="(val)=>{selectRow=val}">
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo_interview" :key="i"
          :prop="x.key" :label="x.value" :fixed="i<=5" align="center"></el-table-column>
        <el-table-column label="文件" width="362" align="center">
          <template slot-scope="scope">
            <p v-for="(x,i) in [scope.row.fileNameAndId]" :key="i" class="file-item">
              <span class="file-name">{{x.fileName}}</span>
              <a :href="'https://view.officeapps.live.com/op/view.aspx?src='+puUrl_x+'/'+x.fileId" target="_blank">
                <el-button size="mini" plain type="success">预览</el-button>
              </a>
              <a :download="x.fileName" :href="puUrl_x+'/'+x.fileId" target="_blank" style="margin-left:10px;">
                <el-button size="mini" plain type="primary">下载</el-button>
              </a>
            </p>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="470" align="center"> -->
        <el-table-column label="操作" width="300" align="center">
          <template slot-scope="scope">
            <el-button size="mini" plain type="success" @click="viewInterviewDetailHandler(scope.row.id)">查看详情</el-button>
            <el-button style="margin-right:10px;" size="mini" plain type="success" @click="confirmInterviewHandler(scope.row.id)" :disabled="scope.row.ok">确认面试</el-button>
            <!-- <el-button size="mini" plain type="success" @click="editReceiptHandler(scope.row.id)" :disabled="!scope.row.ok">填写回执</el-button> -->
            <!-- <el-button size="mini" plain type="success" @click="editResaultHandler(scope.row.id)">填写反馈</el-button> -->
            <!-- <el-button size="mini" plain type="success" @click="viewResaultHandler(scope.row.id)" :disabled="!scope.row.ok">查看反馈</el-button> -->
            <el-popover placement="bottom-end" trigger="click">

              <div class="file-box" v-if="feedbackData">
                <p v-for="(x,i) in feedbackData.fileNameAndIds" :key="i" class="file-item">
                  <span class="file-name">{{x.fileName}}</span>
                  <a :href="'https://view.officeapps.live.com/op/view.aspx?src='+puUrl_x+'/'+x.fileId" target="_blank">
                    <el-button size="mini" plain type="success">预览</el-button>
                  </a>
                  <a :download="x.fileName" :href="puUrl_x+'/'+x.fileId" target="_blank" style="margin-left:10px;">
                    <el-button size="mini" plain type="primary">下载</el-button>
                  </a>
                </p>
                <p style="margin-top:20px;" v-if="feedbackData.ok">
                  <el-tag plain type="success">已确认</el-tag>
                </p>
                <p style="margin-top:20px;" v-else>
                  <el-button size="mini" plain type="success" @click="confirmResaultHandler(scope.row.id)" :disabled="!scope.row.ok">确认反馈</el-button>
                </p>
              </div>

              <div class="file-box" v-else>
                <p class="file-name">暂无反馈</p>
              </div>

              <el-button slot="reference" size="mini" plain type="success" @click="viewResaultHandler(scope.row.id)">查看反馈</el-button>
            </el-popover>
            <!-- <el-button size="mini" plain type="success" @click="confirmResaultHandler(scope.row.id)" :disabled="!scope.row.ok">确认反馈</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <paging :pagesData="pageData_interview" @set_page_number="pageNumberChange_interview"></paging>
    </el-dialog>
    <!-- 模态框 支付 -->
    <el-dialog
      title="支付信息" :modal="false" width="1200px" center
      :visible.sync="centerDialogVisible_pay_create"
      :close-on-click-modal="false" @close="dialogClose_pay_create">
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">支付详情</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" ref="editForm_pay_create" size="mini" :model="editForm_pay_create">
                    <el-form-item label="名称：">
                      <div>成都竞成人力资源服务股份有限公司</div>
                    </el-form-item>
                    <el-form-item label="开户银行：">
                      <div>兴业银行成都分行提督街支行</div>
                    </el-form-item>
                    <el-form-item label="开户账号：">
                      <div>431020100100149798</div>
                    </el-form-item>
                    <div style="height:30px;"></div>
                    <el-form-item label="上传凭证">
                      <!-- <el-upload
                        style="width:400px;" multiple list-type="picture-card"
                        :action="$api.url_upload_pu" accept=".jpg,.jpeg,.png,.bmp,.gif" :file-list="fileList_pay" :limit="1"
                        :on-success="uploadSuccess_pay" :on-remove="uploadRemove_pay">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">仅支持上传图片文件</div>
                      </el-upload> -->
                      <el-upload
                        :action="$api.url_upload_pu" multiple :limit="1" accept=".jpg,.jpeg,.png,.bmp,.gif"
                        :file-list="fileList_pay" list-type="picture-card"
                        :class="{'disabled':fileList_pay.length>=1}"
                        :on-success="uploadSuccess_pay" :on-remove="uploadRemove_pay"
                        :on-preview="handlePictureCardPreview">
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose_pay_create()">取 消</el-button>
        <el-button type="primary" @click="dialogSubmit_pay_create()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import areaFilter from '@/components/areaFilter'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_3g48_back'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { areaFilter },
  data() {
    return {
      // sign: 'qiye',

      editForm_contract_view: {},
      tableData_contract: [],
      baseInfo_contract: [
        { key: 'name', value: '合同名称' },
        { key: 'showDate', value: '发起时间' },
        { key: 'okText', value: '签约状态' },
        { key: 'okDate', value: '签约时间' },
      ],

      pageData_contract: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
      },

    // ——————————————————————————————————————————————————————————————————————
      
      centerDialogVisible_interview_create: false,
      editForm_interview_create: {
        interviewArrangeList: [
          { time: '', startTime: '', endTime: '', activity: '', address: '' }
        ],
        interviewDocList: [
          { name: '', title: '', sex: '', phone: '' }
        ],
      },
      editForm_interview_create_ori: {},

      centerDialogVisible_interview_view: false,
      editForm_interview_view: {},
      tableData_interview: [],
      baseInfo_interview: [
        { key: 'inviteName', value: '面试邀请名称' },
        { key: 'no', value: '序列号' },
        // { key: 'organization', value: '单位名称' },
        // { key: 'qq', value: '单位QQ/E-mail' },
        // { key: 'daTing', value: '大厅名称' },
        // { key: 'name', value: '用户名' },
        // { key: 'password', value: '密码' },
        // { key: 'month', value: '书面电邮反馈月份' },
        // { key: 'day', value: '书面电邮反馈日号' },
        { key: 'okText', value: '确认状态' },
        { key: 'okDate', value: '确认时间' },
      ],
      isShowFeedback: false,

      pageData_interview: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
      },
    
      // tableData_feedback: [],
      feedbackData: {},

      
      centerDialogVisible_pay_create: false,
      editForm_pay_create: {},
      fileList_pay: [],

      dialogImageUrl: '',                // 预览图片路径
      dialogVisible: false,              // 预览对话框是否可见
    }
  },
  methods: {
    resetHandler() {
      this.filterForm = {}
      this.$refs.areaFilter_filter.reset()
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // ——————————————————————————————————————————————————————————————————————
    // 查看合同列表
    viewContractHandler(userId = this.editForm_contract_view.userId) {
      console.log(`%c企业ID:`, 'color: #00f;', userId)
      this.centerDialogVisible_contract_view = true
      this.editForm_contract_view.userId = userId
      let rD = {
        userId,
        pageNumber: this.pageData_contract.currentPage,
      }
      this.$api.util_search('hetong', rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c合同列表:`, 'color: #f00;', _R)
          this.tableData_contract = _R.map(x => {
            x.okText = x.ok ? '已签约' : '未签约'
            return x
          })
          this.pageData_contract.total = res.data.size
        } else { this._status(res.data) }
      })
    },
    // 查看合同 页码
    pageNumberChange_contract(pageNumer) {
      this.pageData_contract.currentPage = pageNumer
      this.viewContractHandler()
    },
    // 查看合同 签约
    signContractHandler(contractId) {
      console.log(`%c签约:`, 'color: #f00;', contractId)
      this.$confirm('确定合同文件无误后签约？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.signContract({ id: contractId }).then(res => {
          if (res.data.status == 0) {
            this.$message.success('签约成功！')
          } else { this._status(res.data) }
        })
      }).catch(() => {})
    },
    // 查看合同 申请发票
    applyInvoiceHandler(contractId) {
      console.log(`%c申请发票ID:`, 'color: #00f;', contractId)
      let rD= {
        contractId
      }
      this.$api.util_create('fapiao', rD).then(res => {
        if (res.data.status == 0) {
          this.$message.success('申请成功！')
        } else { this._status(res.data) }
      })
    },
    // ——————————————————————————————————————————————————————————————————————
    // 发起招聘会 关闭
    dialogClose_interview_create() {
      this.centerDialogVisible_interview_create = false
      this.editForm_interview_create = {
        interviewArrangeList: [
          { time: '', startTime: '', endTime: '', activity: '', address: '' }
        ],
        interviewDocList: [
          { name: '', title: '', sex: '', phone: '' }
        ],
      }
      this.isShowFeedback = false
    },
    dialogSubmit_interview_create() {
      console.log(this.editForm_interview_create)
      // if (this.editForm_interview_create.interviewInviteId) {
        let rD = {}
        // const mapList = [
        //   'no',
        //   'daTing',
        //   'name',
        //   'password',
        //   'month',
        //   'day',
        //   'organization',
        //   'qq',
        //   'inviteName',
        // ]
        // mapList.forEach(x => {
        //   if (this.editForm_interview_create[x] !== this.editForm_interview_create_ori[x]) {
        //     rD[x] = this.editForm_interview_create[x]
        //   }
        // })
        const mapList2 = [
          'interviewArrangeList',
          'interviewDocList',
          'organization',
          'qq',
        ]
        mapList2.forEach(x => {
          if (JSON.stringify(this.editForm_interview_create[x]) !== JSON.stringify(this.editForm_interview_create_ori[x])) {
            rD[x] = this.editForm_interview_create[x]
          }
        })
        rD.id = this.editForm_interview_create.interviewInviteId
        console.log(`%crD:`, 'color: #00f;', rD)
        this.$api.util_modify('mianshihui', rD).then(res => {
          if (res.data.status == 0) {
            this.$message.success('填写成功！')
            this.viewInterviewHandler()
          } else { this._status(res.data) }
        })
      // } else {
      //   this.$api.util_create('mianshihui', this.editForm_interview_create).then(res => {
      //     if (res.data.status == 0) {
      //       this.$message.success('发起成功！')
      //     } else { this._status(res.data) }
      //   })
      // }
    },
    addInterview() {
      this.editForm_interview_create.interviewArrangeList.push({
        time: '',
        startTime: '',
        endTime: '',
        activity: '',
        address: '',
      })
    },
    addFeedback() {
      this.editForm_interview_create.interviewDocList.push({
        name: '',
        title: '',
        sex: '',
        phone: '',
      })
    },
    // ——————————————————————————————————————————————————————————————————————
    // 查看招聘会列表
    viewInterviewHandler(contractId = this.editForm_interview_view.contractId) {
      console.log(`%c合同ID:`, 'color: #00f;', contractId)
      this.centerDialogVisible_interview_view = true
      this.editForm_interview_view.contractId = contractId
      let rD = {
        contractId,
        pageNumber: this.pageData_interview.currentPage,
      }
      this.$api.util_search('mianshihui', rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c面试会列表:`, 'color: #f00;', _R)
          this.tableData_interview = _R.map(x => {
            x.okText = x.ok ? '已确认' : '未确认'
            return x
          })
          this.pageData_interview.total = res.data.size
        } else { this._status(res.data) }
      })
    },
    // 查看招聘会 关闭
    dialogClose_interview_view() {
      this.centerDialogVisible_interview_view = false
      this.editForm_interview_view = {}
    },
    // 查看招聘会 页码
    pageNumberChange_interview(pageNumer) {
      this.pageData_interview.currentPage = pageNumer
      this.viewInterviewHandler()
    },
    // 查看招聘会 查看详情
    viewInterviewDetailHandler(interviewInviteId) {
      console.log(`%c查看详情ID:`, 'color: #00f;', interviewInviteId)
      this.centerDialogVisible_interview_create = true
      this.editForm_interview_create.interviewInviteId = interviewInviteId
      let rD = {
        id: interviewInviteId
      }
      this.$api.util_search('mianshihui', rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c面试会详情:`, 'color: #f00;', _R[0])
          this.editForm_interview_create = _R[0]
          this.editForm_interview_create.interviewInviteId = interviewInviteId
          this.editForm_interview_create_ori = JSON.parse(JSON.stringify(_R[0]))
          this.editForm_interview_create_ori.interviewInviteId = interviewInviteId
        } else { this._status(res.data) }
      })
    },
    // 查看招聘会 确认面试
    confirmInterviewHandler(interviewInviteId) {
      console.log(`%c确认面试ID:`, 'color: #00f;', interviewInviteId)
      this.$confirm('确定面试详情无误？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.signInterview({ id: interviewInviteId }).then(res => {
          if (res.data.status == 0) {
            this.$message.success('确认成功！')
            this.viewInterviewHandler()
          } else { this._status(res.data) }
        })
      }).catch(() => {})
    },
    // 查看招聘会 填写回执
    editReceiptHandler(interviewInviteId) {
      console.log(`%c填写回执ID:`, 'color: #00f;', interviewInviteId)
      this.isShowFeedback = true
      this.viewInterviewDetailHandler(interviewInviteId)
    },
    // 查看招聘会 查看反馈
    viewResaultHandler(interviewInviteId) {
      console.log(`%c查看反馈ID:`, 'color: #00f;', interviewInviteId)
      let rD = {
        interviewInviteId
      }
      this.$api.util_search('mianshihuifankui', rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c反馈详情:`, 'color: #f00;', _R[0])
          // this.tableData_feedback = _R
          this.feedbackData = _R[0]
        } else { this._status(res.data) }
      })
    },
    // 查看招聘会 确认反馈
    confirmResaultHandler(interviewInviteId) {
      console.log(`%c确认反馈ID:`, 'color: #00f;', this.feedbackData.id)
      this.$confirm('确定反馈结果无误？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.signFeedback({ id: this.feedbackData.id }).then(res => {
          if (res.data.status == 0) {
            this.$message.success('确认成功！')
          } else { this._status(res.data) }
        })
      }).catch(() => {})
    },
    // ——————————————————————————————————————————————————————————————————————
    // 发起反馈
    editResaultHandler(interviewInviteId) {
      console.log(`%c填写反馈ID:`, 'color: #00f;', interviewInviteId)
      this.centerDialogVisible_feedback_create = true
      this.editForm_feedback_create.interviewInviteId = interviewInviteId
      this.fileList_feedback = [
        // {name: 'food.doc', id: '32143154132135.doc'},
        // {name: 'food2.doc', id: '32143154343135.doc'},
      ]
    },
    // 发起反馈 关闭
    dialogClose_feedback_create() {
      this.centerDialogVisible_feedback_create = false
      this.editForm_feedback_create = {}
      this.fileList_feedback = []
    },
    // 发起反馈 提交
    dialogSubmit_feedback_create() {
      console.log(this.editForm_feedback_create, this.fileList_feedback)
      this.editForm_feedback_create.fileNameAndIds = this.fileList_feedback.map(x => {
        return {
          fileName: x.name,
          fileId: x.id,
        }
      })
      this.$api.util_create('mianshihuifankui', this.editForm_feedback_create).then(res => {
        if (res.data.status == 0) {
          this.$message.success('填写成功！')
        } else { this._status(res.data) }
      })
    },
    // 发起反馈 上传成功
    uploadSuccess(response, file, fileList) {
      // console.log('%cfileList:', 'color: #0ff;', response, file, fileList)
      fileList.forEach(x => {
        x.response ? x.id = JSON.parse(x.response.data).fileId : ''
      })
      this.fileList_feedback = fileList
    },
    // 发起反馈 上传移除
    uploadRemove(file, fileList) {
      this.fileList_feedback = fileList
    },
    // ——————————————————————————————————————————————————————————————————————
    // 发起支付
    payContractHandler(contractId, row) {
      console.log(`%c填写支付ID:`, 'color: #00f;', contractId, row)
      this.centerDialogVisible_pay_create = true
      this.editForm_pay_create.id = contractId
      this.fileList_pay = row.transferUrl ? [
        { name: row.transferUrl, id: row.transferUrl, url: this.puUrl_x + '/' + row.transferUrl },
        // {name: 'food2.doc', id: '32143154343135.doc'},
      ] : []
    },
    // 发起支付 关闭
    dialogClose_pay_create() {
      this.centerDialogVisible_pay_create = false
      this.editForm_pay_create = {}
      this.fileList_pay = []
    },
    // 发起支付 提交
    dialogSubmit_pay_create() {
      console.log(this.editForm_pay_create, this.fileList_pay)
      // this.editForm_pay_create.transferUrl = this.fileList_pay.map(x => {
      //   return {
      //     fileName: x.name,
      //     fileId: x.id,
      //   }
      // })
      if (this.fileList_pay[0]) {
        this.editForm_pay_create.transferUrl = this.fileList_pay[0].id
        this.$api.util_modify('hetong', this.editForm_pay_create).then(res => {
          if (res.data.status == 0) {
            this.$message.success('提交成功！')
            this.dialogClose_pay_create()
          } else { this._status(res.data) }
        })
      } else {
        this.dialogClose_pay_create()
      }
    },
    // 发起支付 上传成功
    uploadSuccess_pay(response, file, fileList) {
      // console.log('%cfileList:', 'color: #0ff;', response, file, fileList)
      fileList.forEach(x => {
        x.response ? x.id = JSON.parse(x.response.data).fileId : ''
      })
      this.fileList_pay = fileList
    },
    // 发起支付 上传移除
    uploadRemove_pay(file, fileList) {
      this.fileList_pay = fileList
    },
    // ——————————————————————————————————————————————————————————————————————
    
    // 请求合同数据
    getData(rD = {}) {
      this.viewContractHandler(this.userInfo.id)
    },
  },
  created() {
    // const powerList = this.userInfo.privilegesList
    // const powerStr = powerMap[this.sign]
    // const mapList = ['search','create','modify','delete','import','export']
    // if (this.userInfo.admin) {
    //   mapList.forEach(x => {
    //     this.powerShow[x] = true
    //   })
    // } else {
    //   mapList.forEach(x => {
    //     if (powerList.includes(powerStr + '-' + x)) {
    //       this.powerShow[x] = true
    //     }
    //   })
    // }
  },
}
</script>

<style lang='scss' scoped>
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
/deep/.el-upload-list__item{transition:none;}

.file-box{min-width: 320px;padding: 20px;}
.file-item{height: 40px;line-height: 40px;display: flex;}
.file-name{
  display: inline-block;min-width: 120px;max-width: 200px;padding: 0 10px;
  overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
}

/deep/ .el-upload--picture-card,
/deep/ .el-upload-list__item {width:90px;height:90px;position:relative;transition:none !important;} // 图片盒子大小
/deep/ .el-icon-plus {width:28px;height:28px; position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;} // 图片加号位置
/deep/ .disabled .el-upload--picture-card {display:none} // 图片超出数量限制 隐藏上传按钮
</style>